import { render, staticRenderFns } from "./LocalAppConnect.vue?vue&type=template&id=0251d670&"
import script from "./LocalAppConnect.vue?vue&type=script&lang=ts&"
export * from "./LocalAppConnect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports